export default __webpack_public_path__ + "static/media/spinner-bg-mobile.17005ea4.png";